import { Component, Input } from '@angular/core';
import { NgbActiveModal }   from '@ng-bootstrap/ng-bootstrap';

import { SecretKeysModel } from './typings/secret-keys';

@Component({
  selector   : 'wor-secret-keys',
  template: require('./secret-keys.component.html')
})
export class SecretKeysComponent {
  @Input() keys : SecretKeysModel;

  constructor (
    public activeModal: NgbActiveModal
  ) {}
}
